import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import {forkJoin, Observable, of} from 'rxjs';
import {NavigationService} from "./core/navigation/navigation.service";
import {UserService} from "./core/user/user.service";

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _userService: UserService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {

        // Kvůli "Too Many Attempts."
        if(state?.url === '/500-internal-server-error'){
            return this._navigationService.get();
        }

        // Fork join multiple API endpoint calls to wait all of them to finish

        return forkJoin([this._navigationService.get()]);

        //return this._navigationService.get();
        //return of(true);
    }
}
